export const section = {
  name: 'Featured art',
  viewAllLink: '/art/',
};
